"use client";

import { fetchPosts } from "@/utils/api";

interface ParamType {
    search: string | null;
    tags?: string;
  }

//TODO: make this global across all the three search and filter we have 
/*
Three search point: at the moment:
1) Scrolling 
2) Tree search 
3) Search Input 

How they work: and should be tested on any change here- TODO: change this to test cases 
1) If no tags are selected -> All blogs are returned 
2) A child tag is selected -> returns only the post for that Tag 
3) Search Item:: search content has precedence over tags
    1) When a search term is there and a tags -> return search related to tags -- search has more prefernce 
    2) When a search term is there with no tags -> return search 
    3) When a search already and tags are removed -> return search  only 
    4) Anything, scrolling or tree search ->  should return search content 
 */
export const loadFunc = async (
    hasNext: boolean,
    nextUrl: string | undefined,
    search: string | null,
    checkedTags: string[],
    blogPosts: any[],
    setBlogPosts: (posts: any[]) => void,
    setHasNext: (hasNext: boolean) => void,
    setNextUrl: (nextUrl: string ) => void,
    setCount: (value: number) => void,
  ) => {

    if (!hasNext) {
      return;
    }
  
    let param: ParamType = { search };
  
    if (checkedTags && checkedTags.length > 0) {
      param.tags = checkedTags.join(',');
    }
    
    const data = await fetchPosts(nextUrl, param);
  
    const newBlogPosts = [...blogPosts, ...data.posts];
    setBlogPosts(newBlogPosts);
    setCount(data.count);
  
    if (!data.next) {
      setHasNext(false);
    }
    setNextUrl(data.next);
  };
  